














































































































































import SharedContentSideCard from "@/components/partner/SharedContentSideCard.vue";
import MExpansion from "@/components/utility/mmmint/MExpansion.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IClearance } from "@/models/clearance.entity";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { IReport } from "@/models/report.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import ClearanceApprovalSheet from "./ReportClearanceApprovalSheet.vue";
import ReportClearanceUpdateStatusDialog from "./ReportClearanceUpdateStatusDialog.vue";

@Component({
  components: {
    ClearanceApprovalSheet,
    MExpansion,
    MTextField,
    MIconButton,
    SharedContentSideCard,
    SelectAssignees,
    ReportClearanceUpdateStatusDialog
  }
})
export default class PartnerReportClearanceCard extends mixins(PermissionMixin) {
  @Prop()
  clearance!: IClearance;

  @Prop()
  report!: IReport;

  showClearanceApprovals = true;
  isByPassRules = false;
  isUpdateStatusDialogOpen = false;

  sharedContentSideCardItem?: ISharedContent | null = null;

  get sellerCompanyName() {
    return this.clearance.seller?.name || "";
  }

  get filters() {
    const filter: IPageFilterElement[] = [];
    if (!this.report) return filter;

    filter.push(new PageFilterElement({ value: this.report.id, key: "refs.refId", operation: "$eq" }));

    return filter;
  }

  get numberOfImages() {
    return this.clearance?.images?.length || 0;
  }

  @Watch("clearance.allApprovalsCleared")
  onAllApprovalsClearedChange(newValue: boolean) {
    this.isByPassRules = newValue;
  }

  async onAssigneesUpdate(assignees: []) {
    await this.clearance.updatePartial({ assignees });
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.canUpdateClearance) return;
    await this.clearance.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.canUpdateClearance) return;
    await this.clearance.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
  }

  goToDetail() {
    if (this.canReadClearance) {
      this.clearance.goTo(this.$router).detail();
    }
  }

  mounted() {
    if (this.clearance.isCompleted) {
      this.showClearanceApprovals = false;
    }
  }
}
